import { render, staticRenderFns } from "./LightDesign.vue?vue&type=template&id=67d360f5&scoped=true&"
import script from "./LightDesign.vue?vue&type=script&lang=js&"
export * from "./LightDesign.vue?vue&type=script&lang=js&"
import style0 from "./LightDesign.vue?vue&type=style&index=0&id=67d360f5&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67d360f5",
  null
  
)

export default component.exports